<template>
	<div class="score-container">
		<!-- 汇总 -->
		<div style="margin: 10px 0">
		截至目前：积分总量 {{ allCount.totalPointCount }},拉新奖励积分{{
			allCount.newRewardCount
		}}，消费奖励积分{{ allCount.consumeRewardCount }},每日签到奖励积分{{ allCount.dailySignRewardCount }},
		特殊奖励积分{{ allCount.specialRewardCount }},兑换产品积分{{ allCount.exchangeProductCount }}
		</div>
		
		<!-- 标签页 -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="tab-box">
			<!-- 积分统计 -->
			<el-tab-pane label="积分统计" name="scoreStat">
				<!-- 查询区域 -->
				<div class="query-row">
					<div class="query-item">
						<span>时间:</span>
						<el-date-picker
								v-model="statQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width: 280px"
						/>
					</div>
					<div class="query-item">
						<span>积分类型:</span>
						<el-select v-model="statQuery.reason" placeholder="请选择积分类型" clearable>
							<el-option v-for="item in reasonOptions" 
      							:key="item.value" 
      							:label="item.label" 
      							:value="item.value">
							</el-option>
						</el-select>
						
					</div>
					<el-button type="primary" @click="getStatList">查询</el-button>
				</div>
				
				<!-- 积分统计表格 -->
				<el-table
						:data="statList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="系统日期" prop="dateTime" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 0">{{ scope.row.dateTime }}</div>
						</template>
					</el-table-column>
					<el-table-column label="积分总量" prop="pointCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="拉新奖励" prop="pointNewCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="消费奖励" prop="pointExpenseCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="每日签到奖励" prop="pointSignCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="特殊奖励" prop="pointSpecialCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="兑换产品" prop="pointExchangeCount" header-align="center" align="center"></el-table-column>
				</el-table>
				
				<!-- 合计行 -->
<!--				<div class="total-row">-->
<!--					合计: 8975800000 &nbsp;&nbsp;&nbsp; 64322000 &nbsp;&nbsp;&nbsp; 367000 &nbsp;&nbsp;&nbsp; 864540000 &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; -68099000-->
<!--				</div>-->
				
				<!-- 统计分页 -->
				<div class="pager-box">
					<span>共{{ statTotal }}条</span>
					<el-pagination
							:page-sizes="[20, 50, 100]"
							:page-size="statPage.pageSize"
							:current-page="statPage.pageNum"
							:total="statTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="statSizeChange"
							@current-change="statPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 积分明细 -->
			<el-tab-pane label="积分明细" name="scoreDetail">
				<!-- 查询区域 -->
				<div class="query-row detail-query">
<!--					<div class="query-item">-->
<!--						<span>用户微信号:</span>-->
<!--						<el-input v-model="detailQuery.wxId" placeholder="请输入用户微信号" style="width: 160px"></el-input>-->
<!--					</div>-->
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="detailQuery.userName" placeholder="请输入用户姓名" style="width: 160px"></el-input>
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="detailQuery.phone" placeholder="请输入手机号" style="width: 160px"></el-input>
					</div>
					<div class="query-item">
						<span>积分类型:</span>
						<el-select v-model="detailQuery.reason" placeholder="请选择积分类型" clearable>
							<el-option v-for="item in reasonOptions" 
      							:key="item.value" 
      							:label="item.label" 
      							:value="item.value">
							</el-option>
						</el-select>
						
					</div>
					
					<el-button type="primary" @click="resetDetailQuery">重置查询条件</el-button>
					<el-button type="primary" @click="getDetailList">查询</el-button>
				</div>
				
				<!-- 积分明细表格 -->
				<el-table
						:data="detailList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="订单编号" prop="orderCode" header-align="center" align="center"></el-table-column>
					<el-table-column label="积分" prop="point" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="用户微信号" prop="wxId"></el-table-column>-->
					<el-table-column label="用户姓名" prop="nickName" header-align="center" align="center"></el-table-column>
					<el-table-column label="手机" prop="phoneNumber" header-align="center" align="center"></el-table-column>
					<el-table-column label="积分时间" prop="createTime" header-align="center" align="center"></el-table-column>
					<el-table-column label="类型" prop="reason" header-align="center" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.reason === 1">消费奖励</el-tag>
							<el-tag v-if="scope.row.reason === 2">每日签到</el-tag>
							<el-tag v-if="scope.row.reason === 3">邀请注册奖励</el-tag>
							<el-tag v-if="scope.row.reason === 4">兑换产品</el-tag>
							<el-tag v-if="scope.row.reason === 5">特殊奖励</el-tag>
						</template>
					</el-table-column>
				</el-table>
				
				<!-- 明细分页 -->
				<div class="pager-box">
					<span>共{{ detailTotal }}条</span>
					<el-pagination
							:page-sizes="[20, 50, 100]"
							:page-size="detailPage.pageSize"
							:current-page="detailPage.pageNum"
							:total="detailTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="detailSizeChange"
							@current-change="detailPageChange"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// 引入后台接口（请根据实际项目的接口路径调整）
import {
	getWebScoreStatListPageCount,
	getWebScoreStatListPage,
	getWebScoreDetailListPageCount,
	getWebScoreDetailListPage, getStatisticUserQmxfPointLogListDataPageCount, getStatisticUserQmxfPointLogListDataPage,
	getPointSummary
} from "../../api/api"; // 假设积分相关接口在此路径
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
export default {
	name: "PointsStatistics",
	data() {
		return {
			// 当前激活标签
			activeTab: "scoreStat",
			// 总条数（初始化为0，从接口获取）
			statTotal: 749,
			detailTotal: 749,
			
			// ============= 积分统计 =============
			statQuery: {
				dateRange: "",
				reason:""

			},
			statPage: {
				pageNum: 1,
				pageSize: 20
			},
			statList: [],
			
			// ============= 积分明细 =============
			detailQuery: {
				wxId: undefined,
				userName: '',
				phone: '',
				reason:''
			},
			detailPage: {
				pageNum: 1,
				pageSize: 20
			},
			detailList: [],
			reasonOptions:[
				{
					value:"1",
					label:"消费奖励"
				},
				{
					value:"2",
					label:"每日签到"
				},
				{
					value:"3",
					label:"邀请注册奖励"
				},
				{
					value:"4",
					label:"兑换产品"
				},
				{
					value:"5",
					label:"特殊奖励"
				}
			],
			allCount:""
		};
	},
		mounted() {
		// 添加全局回车搜索功能
		useEnterSearch(() => {
			if (this.activeTab === "scoreStat") {
				this.statPage.pageNum = 1;
				this.getStatList();
			} else if (this.activeTab === "scoreDetail") {
				this.detailPage.pageNum = 1;
				this.getDetailList();
			}
		});
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	methods: {
		getPointSummaryFun(){
			getPointSummary().then(res=>{
				if(res.data.success){
					this.allCount = res.data.response;
				}
			})
		},
		// 切换标签页重新加载数据
		changeSelectValue(value) {
			this.activeTab = value.name;
			console.log("切换标签页：", value);
			if (value.name === "scoreStat") {
				this.statPage.pageNum = 1;
				this.getStatList();
			} else if (value.name === "scoreDetail") {
				this.detailPage.pageNum = 1;
				this.getDetailList();
			}
		},
		
		// ========== 积分统计 ==========
		async getStatList() {
			try {
				// 封装查询参数（根据后台接口要求调整字段名）
				const params = {
					pageIndex: this.statPage.pageNum,
					pageSize: this.statPage.pageSize,
					// 处理日期范围：拆分成开始/结束日期
					startTime: this.statQuery.dateRange ? this.statQuery.dateRange[0] : '',
					endTime: this.statQuery.dateRange ? this.statQuery.dateRange[1] : '',
					reason:this.statQuery.reason
				};
				
				// 调用统计接口
				const res = await getStatisticUserQmxfPointLogListDataPageCount(params);
				
				if (res.data.success) { // 假设接口返回success为成功
					this.statList = res.data.response.data;
					this.statTotal = res.data.response.dataCount;
				} else {
					this.$message.error(res.data.message || "积分统计查询失败");
				}
			} catch (error) {
				console.error("积分统计查询异常：", error);
				this.$message.error("网络异常，积分统计查询失败");
			}
		},
		statSizeChange(val) {
			this.statPage.pageSize = val;
			this.getStatList(); // 分页大小变化时重新查询
		},
		statPageChange(val) {
			this.statPage.pageNum = val;
			this.getStatList(); // 页码变化时重新查询
		},
		
		// ========== 积分明细 ==========
		// 重置查询条件
		resetDetailQuery() {
			this.detailQuery = {
				wxId: undefined,
				userName: '',
				phone: '',
				reason:''
			};
		},
		// 查询明细（核心：调用后台接口）
		async getDetailList() {
			try {
				// 1. 封装查询参数（适配后台接口字段要求）
				const params = {
					// 分页参数
					pageIndex: this.detailPage.pageNum,
					pageSize: this.detailPage.pageSize,
					// 基础查询条件
					// wxId: this.detailQuery.wxId.trim() || '',
					nickName: this.detailQuery.userName.trim() || '',
					phoneNumber: this.detailQuery.phone.trim() || '',
					reason:this.detailQuery.reason || ''
				};
				
				// 2. 查分页列表
				const listRes = await getStatisticUserQmxfPointLogListDataPage(params);
				if (listRes.data.success) {
					this.detailList = listRes.data.response.data;
					this.detailTotal = listRes.data.response.dataCount;
				} else {
					this.$message.error(listRes.data.message || "积分明细查询失败");
				}
			} catch (error) {
				console.error("积分明细查询异常：", error);
				this.$message.error("网络异常，积分明细查询失败");
			}
		},
		detailSizeChange(val) {
			this.detailPage.pageSize = val;
			this.getDetailList(); // 分页大小变化重新查询
		},
		detailPageChange(val) {
			this.detailPage.pageNum = val;
			this.getDetailList(); // 页码变化重新查询
		}
	},
	created() {
		this.getStatList();
		this.getPointSummaryFun()
	}
};
</script>

<style scoped>
.score-container {
	width: 98%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}

.top-total {
	font-size: 14px;
	color: #333;
	margin-bottom: 15px;
}

.tab-box {
	margin-top: 5px;
}

.query-row {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-wrap: wrap;
}

.detail-query {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 4px;
}

.query-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #666;
}

.pager-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	font-size: 14px;
	color: #666;
}

/* 合计行样式 */
.total-row {
	padding: 10px 15px;
	background: #fafafa;
	border: 1px solid #ebeef5;
	border-top: none;
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
</style>